import React, { memo } from "react";
import "./Modal.css";

import IconButton from "../buttons/IconButton";

export type ModalProps = {
  opened: boolean;
  title: string;
  children: React.ReactNode;
  onClose: () => void;
};

const Modal = ({ opened, title, onClose, children }: ModalProps) => {
  return (
    <>
      {opened ? (
        <div className="background-modal fade-in-bg">
          <div className="dinamic-modal" role="dialog">
            <div className="w-full flex flex-row justify-between items-center max-md:border-b max-md:border-b-ib-pt-color-gray-300 max-md:p-4 md:pt-6 md:px-6 bg-ib-pt-color-white rounded-t-md md:rounded-t-sm">
              <div className="text-ib-pt-lg md:text-[24px] md:leading-[26px] leading:font-[IberiaHeadline] text-ib-pt-color-neutral-800">
                {title}
              </div>
              <IconButton
                icon="close"
                onClick={onClose}
                className="text-ib-pt-color-red-500 p-0 bg-transparent"
                iconClassName="size-6"
              />
            </div>
            <div className="px-4 pb-4 md:px-6 md:pb-6">{children}</div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default memo(Modal);
